export const CACHE_TTL = {
  SUGGESTED_USERS: 15 * 60 * 1000,
  SEARCH_RESULTS: 5 * 60 * 1000,
  USER_PROFILE: 30 * 60 * 1000,
} as const;

export const isCacheStale = (lastUpdated: number, ttl: number): boolean => {
  if (lastUpdated === 0) return true;

  const now = Date.now();
  const cacheAge = now - lastUpdated;

  return cacheAge > ttl;
};

export const isSuggestedUsersCacheStale = (lastUpdated: number): boolean => {
  return isCacheStale(lastUpdated, CACHE_TTL.SUGGESTED_USERS);
};

export const getCacheStatus = (lastUpdated: number, ttl: number) => {
  const now = Date.now();
  const cacheAge = now - lastUpdated;
  const isStale = isCacheStale(lastUpdated, ttl);
  const timeUntilStale = isStale ? 0 : ttl - cacheAge;

  return {
    isStale,
    cacheAge,
    timeUntilStale,
    lastUpdated: new Date(lastUpdated),
    ttl,
  };
};
